<div
  class="selectable-card"
  [ngClass]="{ highlighted: (!isSelectable && isHighlighted) || isSelected }"
>
  @if (imageSrc !== '') {
    <img class="card-img" src="{{ imageSrc }}" />
  }
  <p class="card-title">{{ title }}</p>
  @if (!isSelectable) {
    <img class="card-icon" src="../../../assets/images/icon/card-next.svg" />
  }
  @if (isSelectable && isSelected) {
    <img
      class="card-icon"
      src="../../../assets/images/icon/card-selected.svg"
    />
  }
  @if (isSelectable && !isSelected) {
    <span class="card-icon"></span>
  }
</div>
